'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './navBar';
import SideMenu from './sideMenu';
import attdAction from '../actions/attdAction';
import attdStore from '../stores/attdStore';
import menuAction from '../actions/menuAction';
import modalAction from '../actions/modalAction';
import Loading from './loading';
import genFunction from '../functions/genFunction';

class AttendanceCheck extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.punchBtn = this.punchBtn.bind(this);
        this.handleRemark = this.handleRemark.bind(this);
        this.handleError = this.handleError.bind(this);
        this.state = {
            processing: attdStore.getState().processing,
            attendanceId: attdStore.getState().attendanceId,
            startWorkHr: attdStore.getState().startWorkHr,
            startWorkMin: attdStore.getState().startWorkMin,
            endWorkHr: attdStore.getState().endWorkHr,
            endWorkMin: attdStore.getState().endWorkMin,
            remark: "",
            canSubmit: attdStore.getState().canSubmit
        };
    }

    componentDidMount() {
        attdStore.listen(this.onChange);
        if (!this.state.processing) {
            attdAction.processing(true);
            attdAction.checkInitAttendance();
        }

        menuAction.pageNumber.defer(-1);
    }
    componentWillUnmount() {
        attdStore.unlisten(this.onChange);
    }
    handleRemark(e) {
        let value = e.target.value;
        this.setState({
            remark: value
        });
    }
    handleError() {
        modalAction.modalContent({
            title: "Error",
            content: "Sorry, no position available."
        });
        modalAction.modalClose(true);
    }

    onChange(state) {
        this.setState({
            processing: state.processing,
            attendanceId: state.attendanceId,
            startWorkHr: state.startWorkHr,
            startWorkMin: state.startWorkMin,
            endWorkHr: state.endWorkHr,
            endWorkMin: state.endWorkMin,
            canSubmit: state.canSubmit
        });
    }

    punchBtn(e) {
        let today = new Date();
        let s = this.state;
        let timeInCheck = new Date(today.getFullYear(), today.getMonth(), today.getDate(), s.startWorkHr, s.startWorkMin);
        let timeOutCheck = new Date(today.getFullYear(), today.getMonth(), today.getDate(), s.endWorkHr, s.endWorkMin);
        if(!this.state.canSubmit){
            modalAction.modalContent({
                title: "Warning",
                content: "Please Time Out previous day first"
            });
            modalAction.modalClose(true);
            return;
        }
        if (this.state.attendanceId) {
            //if timeOutearlier
            if (today.getTime() < timeOutCheck.getTime()) {
                if (this.state.remark == "") {
                    modalAction.modalContent({
                        title: "Warning",
                        content: "Remark cannot be empty"
                    });
                    modalAction.modalClose(true);
                    return;
                }
            }
            attdAction.processing(true);
            attdAction.timeOut(this.state.attendanceId, this.state.remark);
        } else {
            if (today.getTime() > timeInCheck.getTime()) {
                if (this.state.remark == "") {
                    modalAction.modalContent({
                        title: "Warning",
                        content: "Remark cannot be empty"
                    });
                    modalAction.modalClose(true);
                    return;
                }
            }
            attdAction.processing(true);
            attdAction.timeIn(this.state.remark);
        }
        this.setState({ remark: "" });
    }
    remarkShow() {
        let today = new Date();
        let s = this.state;
        let timeInCheck = new Date(today.getFullYear(), today.getMonth(), today.getDate(), s.startWorkHr, s.startWorkMin);
        let timeOutCheck = new Date(today.getFullYear(), today.getMonth(), today.getDate(), s.endWorkHr, s.endWorkMin);
        if (today.getTime() > timeInCheck.getTime() && (this.state.attendanceId == "" || this.state.attendanceId == null)) {
            return (
                //You have checked in later than your regular start Time. Please state your reason here
                <textarea rows="4" placeholder="Add remark here"
                    style={{ resize: "none", width: "300px" }} onChange={this.handleRemark}
                    value={this.state.remark} />
            );
        } else if (today.getTime() < timeOutCheck.getTime()) {
            return (
                //You have checked out earlier than your regular end Time. Please state your reason here
                <textarea rows="4" placeholder="Add remark here"
                    style={{ resize: "none", width: "300px" }} onChange={this.handleRemark}
                    value={this.state.remark} />
            );
        }
    }
    render() {
        return (
            <div>
                <Navbar {...this.props} />
                <div className="container-fluid content">
                    <div className="row">
                        <SideMenu {...this.props} />
                        <div className=" col-md-10  col-sm-8 atd">
                            <h4>Attendance (Time In/Time Out)</h4>
                            <div>{new Date().toDateString()}</div>
                            <div className="warning">{this.state.warningMsg}</div>
                            {this.remarkShow()}
                            <div>
                                <button className="atd-pc-1 btn btn-default" onClick={this.punchBtn}>
                                    {this.state.attendanceId ? "Time Out" : "Time In"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <Loading processing={this.state.processing || this.state.processingFilter} />
            </div>
        );
    }
}
export default AttendanceCheck;


// WEBPACK FOOTER //
// ./app/components/attendanceCheck.js